import { FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Switch, TextField } from "@mui/material";

import NumberFormat from "react-number-format";
// import moment from 'moment';

// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import { useSelector } from "react-redux";
import { AutocompleteContacts } from './AutocompleteContacts';

// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers";
import { InputsDates } from "../../reusableUI/InputsDates";


export const DatosIniciales = ({ dataForm, handleChange, handleChangeProveedor, handleChangeDate, handleChangeTipoDoc, handleChangeCheck, handleChangeTipoCambio, handleChangeMoneda }) => {

    const { currencyList, listaFormasPagos, listaTiposDocumentos, info } = useSelector(state => state.general)
    const { local_simbolo, local_separacion_miles, local_separacion_decimales } = info


    const handleChangeDateAux = ({ target }) => {
        const { name, value } = target
        handleChangeDate(value, name)
    }

    return (
        <Grid>
            <Grid item xs={12}>
                <Grid container spacing='20' columnSpacing='16' rowSpacing='12' alignItems='center' direction='row'>

                    <Grid item xs={12} md={8}>

                        <div className="d-flex justify-content-start align-items-center p-text-date">
                            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                    label="Fecha del gasto"
                                    // inputFormat="dd/MM/yyyy"
                                    name="fecha_compra"
                                    value={moment(dataForm.fecha_compra).format('DD-MM-YYYY') || ''}
                                    onChange={(e) => handleChangeDate(e, 'fecha_compra')}
                                    renderInput={(params) => <TextField {...params} />}
                                    disabled={dataForm.reading_mode}
                                />
                            </LocalizationProvider> */}

                            <InputsDates
                                label="Fecha del gasto"
                                name="fecha_compra"
                                value={dataForm.fecha_compra}
                                onHandleChange={handleChangeDateAux}
                                disabled={dataForm.reading_mode}
                            />

                            {dataForm.id > 0 &&
                                <div>
                                    {dataForm.estado === 'pagada' ?
                                        <span className="d-flex justify-content-between align-items-center ms-3 mt-2">
                                            <i className="bi bi-check-lg" style={{ color: 'green', fontSize: '20px' }}></i>
                                            <label style={{ fontSize: '16px' }}>Pagado</label>
                                        </span>
                                        :
                                        <FormControlLabel
                                            className="ms-2 mt-2"
                                            control={
                                                <Switch
                                                    name="pagado"
                                                    checked={dataForm.estado === 'pagada' ? true : false}
                                                    onChange={handleChangeCheck}
                                                />
                                            }
                                            label={dataForm.estado === 'pagada' ? 'Pagado' : 'Pagar'}
                                            disabled={dataForm.reading_mode}
                                        />
                                    }
                                </div>
                            }

                            {dataForm.id > 0 &&
                                <>
                                    {(dataForm.nro_doc_justificacion !== null && dataForm.nro_doc_justificacion !== '') ?
                                        <span className="d-flex justify-content-between align-items-center ms-3 mt-2">
                                            <i className="bi bi-check-lg" style={{ color: 'green', fontSize: '20px' }}></i>
                                            <label style={{ fontSize: '16px' }}>Justificado</label>
                                        </span>
                                        :
                                        <FormControlLabel
                                            className="ms-2 mt-2"
                                            control={
                                                <Switch
                                                    name="justificado"
                                                    checked={(dataForm.nro_doc_justificacion !== null && dataForm.nro_doc_justificacion !== '') ? true : false}
                                                    onChange={handleChangeCheck}
                                                />
                                            }
                                            label={(dataForm.nro_doc_justificacion !== null && dataForm.nro_doc_justificacion !== '') ? 'Justificado' : 'Justificar gasto'}
                                            disabled={dataForm.reading_mode}
                                        />
                                    }
                                </>
                            }

                        </div>

                    </Grid>

                    <Grid item xs={12} md={8} className="mt-1">
                        <TextField
                            label="Descripción de la compra"
                            name="referencia"
                            id="outlined-size-small"
                            value={dataForm.referencia || ''}
                            size="small"
                            fullWidth
                            placeholder='Ingrese descripción de la compra'
                            onChange={handleChange}
                            disabled={dataForm.reading_mode}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Moneda</InputLabel>
                            <Select
                                label="Moneda"
                                id="id_moneda"
                                name="id_moneda"
                                value={dataForm.id_moneda || ''}
                                onChange={handleChangeMoneda}
                                className='p-list-capitalize'
                                disabled={dataForm.reading_mode}
                                style={{ textTransform: 'uppercase' }}
                            >
                                <MenuItem value='' key=''>Ninguno</MenuItem>
                                {currencyList.map(item => (
                                    <MenuItem value={item.id} key={item.id} style={{ textTransform: 'uppercase' }}>
                                        {item.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <AutocompleteContacts
                            dataForm={dataForm}
                            id_proveedor={dataForm.id_proveedor}
                            handleChangeProveedor={handleChangeProveedor}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Tipo de documento</InputLabel>
                            <Select
                                label="Tipo de documento"
                                id="id_tipo_documento"
                                name="id_tipo_documento"
                                value={dataForm.id_tipo_documento || ''}
                                onChange={handleChangeTipoDoc}
                                className='p-list-capitalize'
                                disabled={dataForm.reading_mode}
                            >
                                <MenuItem value='' key=''>Ninguno</MenuItem>
                                {listaTiposDocumentos.map(item => (
                                    <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Forma de pago</InputLabel>
                            <Select
                                label="Forma de pago"
                                id="id_forma_pago"
                                name="id_forma_pago"
                                value={dataForm.id_forma_pago || ''}
                                onChange={handleChange}
                                className='p-list-capitalize'
                                disabled={dataForm.reading_mode}
                            >
                                <MenuItem value='' key=''>Ninguno</MenuItem>
                                {listaFormasPagos.map(item => (
                                    <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <div className="d-flex justify-content-start p-text-date">
                            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                    label="Fecha vencimiento"
                                    inputFormat="dd/MM/yyyy"
                                    name="fecha_vencimiento"
                                    value={dataForm.fecha_vencimiento || ''}
                                    onChange={(e) => handleChangeDate(e, 'fecha_vencimiento')}
                                    renderInput={(params) => <TextField {...params} />}
                                    disabled={dataForm.reading_mode}
                                />
                            </LocalizationProvider> */}

                            <InputsDates
                                label="Fecha vencimiento"
                                name="fecha_vencimiento"
                                value={dataForm.fecha_vencimiento}
                                onHandleChange={handleChangeDateAux}
                                disabled={dataForm.reading_mode}
                            />

                        </div>
                    </Grid>

                    {parseInt(dataForm.id_moneda) === 4 &&
                        < Grid item xs={12} md={2}>
                            <NumberFormat
                                label="Tipo de cambio"
                                customInput={TextField}
                                value={dataForm?.valor_tipo_cambio}
                                thousandSeparator={local_separacion_miles}
                                decimalSeparator={local_separacion_decimales}
                                prefix={`${local_simbolo} `}
                                onValueChange={(values) => handleChangeTipoCambio(values, 'valor_tipo_cambio')}
                                decimalScale={2}
                                disabled={dataForm.reading_mode}
                            />
                        </Grid>
                    }


                </Grid>
            </Grid>
        </Grid >
    );
}
